import { createContext } from 'react'
import useCurrentGameRoute from '../../hooks/useCurrentGameRoute'
import type { GetGameBySlugQuery } from '../../generated/graphql'

export type GameType = GetGameBySlugQuery['getGameBySlug'] | undefined

const GameContext = createContext<GameType | undefined>(undefined)

export const GameProvider = ({ children }) => {
  const { game } = useCurrentGameRoute()

  return <GameContext.Provider value={game}>{children}</GameContext.Provider>
}

export default GameContext
